import React from 'react';

const About: React.FC = () => {
  return (
    <>
      <div className="page-header">
        <div className="container">
          <h1>درباره ما</h1>
        </div>
      </div>
      <section className="about-section">
        <div className="container">
          <h2>کمربند سبز ایران</h2>
          <p>
            ما با هدف تأمین نهاده‌های کشاورزی با کیفیت و ایجاد بستری برای تبادل دانش بین کشاورزان، فعالیت خود را آغاز کرده‌ایم.
          </p>
          <p>
            تیم ما متشکل از کارشناسان مجرب کشاورزی است که با سال‌ها تجربه در زمینه تولید و توزیع محصولات کشاورزی، آماده ارائه بهترین خدمات به شما عزیزان است.
          </p>
          <h3>چشم‌انداز</h3>
          <p>تبدیل شدن به بزرگترین پلتفرم تخصصی کشاورزی در ایران و ارائه خدمات جامع به کشاورزان.</p>
        </div>
      </section>
    </>
  );
};

export default About;